<template>
  <UiConfirm
    ref="confirm"
    class="crm-activity-actions__confirm-send-test-sms"
    :width="480"
    type="success"
    :action-name="$t('crm.buttons.save')"
    :close-action-name="$t('crm.buttons.cancel')"
    action="send_test_sms"
    action-icon="check"
    :action-disabled="isLoading"
    @save="saveEdit"
  >
    <template v-slot:title>
      <div v-html="$t('affiliates.public_profile.edit.title')" />  
    </template>
    
    <UiScrollbar
      wrap-style="max-height: 75vh; height: auto;"
      :native="false"
    >
      <div class="body__wrap">
        <div class="row ui-fg-1">
          <div class="field">
            <UiInput
              v-model="form.name"
              :error="getError('name')"
              :placeholder="$t(`affiliates.public_profile.edit.name`)"
              :label="$t(`affiliates.public_profile.edit.name`)"
              autosize
              size="big"
            />
          </div>
          <div class="field t:mt-16">
            <div
              v-if="form.contacts.length"
              class="contacts"
            >
              <div class="column">
                <UiLabel
                  class="t:mb-8"
                  :label="$t('affiliates.public_profile.edit.messenger')"
                />
              </div>
              <div class="column">
                <UiLabel
                  class="t:mb-8"
                  :label="$t('affiliates.public_profile.edit.messenger_id')"
                />
              </div>
            </div>
            <div
              v-for="(item, i) in form.contacts"
              :key="i"
              class="contacts card"
            >
              <div class="column field">
                <UiSelectElement
                  v-model="item.type"
                  :placeholder="$t('affiliates.public_profile.edit.messenger')"
                  :list="messengers"
                  option-value-param="type"
                  option-name-param="value"
                  option-label-param="value"
                  filterable
                  :error="getError(['contacts', i, 'type'])"
                  size="big"
                >
                  <template v-slot:customPrefix>
                    <div class="prefix">
                      <UiIcon
                        v-if="item.type === 'email'"
                        :size="14"
                        color="var(--text-primary)"
                        name="envelope"
                        class="ico"
                      />
                      <span
                        v-else
                        class="messenger"
                        :class="item.type"
                      />
                    </div>
                  </template>
                </UiSelectElement>
              </div>
              <div class="column">
                <UiInput
                  v-model="item.value"
                  :error="getError(['contacts', i, 'value'])"
                  error-tooltip
                  :placeholder="$t('affiliates.public_profile.edit.messenger_id')"
                  autosize
                  size="big"
                />
                <div
                  class="t:ml-8"
                  @click="deleteMessenger(i)"
                >
                  <UiIcon
                    name="times"
                    class="pointer"
                    :class="{ disabled: form.contacts.length <= 1 }"
                    :size="14"
                    color="var(--text-negative)"
                  />
                </div>
              </div>
            </div>
            <div
              class="add-messenger"
              @click="addMessenger"
            >
              <i class="fas fa-plus" />
              <span>{{ $t('affiliates.public_profile.edit.add_messenger') }}</span>
            </div>
          </div>
          <UiTextarea
            v-model="form.additional_information"
            class="t:mt-16"
            :label="$t('affiliates.public_profile.edit.misc')"
            :maxlength="225"
            :rows="4"
            :placeholder="$t('affiliates.public_profile.edit.misc_placeholder')"
            resize="vertical"
          />
        </div>
      </div>
    </UiScrollbar>
  </UiConfirm>
</template>

<script>
import errorHandleMixin from '@/views/mixins/error-hadle';

export default {
  name: 'EditPublicProfile',
  mixins: [errorHandleMixin],
  props: {
    id: {
      type: String,
      default() {
        return '';
      },
    },
  },
  emits: ['update-affiliate'],

  data() {
    return {
      isLoading: false,
      form: this.defaultData(),
      messengers: [
        {
          type: 'email',
          value: 'Email',
        },
        {
          type: 'telegram',
          value: 'Telegram',
        },
        {
          type: 'ms_teams',
          value: 'MS Teams',
        },
      ],
    };
  },

  methods: {
    defaultData() {
      return {
        name: '',
        contacts: [{
          type: null,
          value: '',
        }],
        additional_information: '',
      };
    },
    open(data) {
      this.errors = {};
      this.form = this.$_.cloneDeep(data || this.defaultData());
      this.$refs.confirm.open();
    },
    addMessenger() {
      this.form.contacts.push({
        type: null,
        value: '',
      });
    },
    deleteMessenger(i) {
      if (this.form.contacts.length <= 1) return;

      this.form.contacts = [...this.form.contacts.slice(0, i), ...this.form.contacts.slice(i + 1)];
    },
    async saveEdit() {
      if (this.isLoading) return;

      this.isLoading = true;
      this.$api.putAffiliatePublicProfile(this.id, this.form)
        .then(() => {
          this.$emit('update-affiliate');
          this.$refs.confirm.close();
        })
        .catch((e) => {
          this.errors = e.data.errors;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-messenger {
  display: flex;
  align-items: center;
  color: var(--text-primary);
  cursor: pointer;
  font-size: 12px;
  margin-top: 16px;

  i {
    font-size: 16px!important;
    line-height: 1.33;
    padding-right: 4px!important;
  }


}

.crm-activity-actions__confirm-send-test-sms{
  .card .field .ico,
  .card .field .messenger:before{
    margin-right: 0;
  }
}

.textarea-wr {
  width: 100%;
  margin-top: 16px;

  .label {
    height: 16px;
    font-size: 14px;
    line-height: normal;
    margin-bottom: 5px;
  }
}

.contacts {
  display: flex;
  align-items: center;
  gap: 16px;

  &.card {
    margin-bottom: 8px;
  }

  .column {
    display: flex;
    align-items: center;
    flex: 1;
    flex-direction: row;

    &.field {
      padding: 0!important;
    }

    .messenger-select {
      &.filled {
        // /deep/ 
        :deep(.el-input__inner) {
          padding-left: 30px;
        }
      }

      .prefix {
        display: flex;
        height: 100%;
        padding-left: 8px;
      }
    }


    .pointer {
      cursor: pointer;
    }

    .disabled {
      cursor: not-allowed !important;
      opacity: 0.5;
    }

    // /deep/ 
    :deep(.el-select.error) {
      .el-input__inner {
        border-color: var(--text-negative);
      }
    }
  }

  .form-title {
    font-size: 14px;
    line-height: normal;
  }
}
</style>
